import types from './types';
import { createTestListReducers } from '../../../common/test-list/reducers';

const { initialState, reducer } = createTestListReducers(types);

export default reducer;
export { initialState };
